// extracted by mini-css-extract-plugin
export default {"spin":"vS9oI","button-container":"NV4jJ","custom-button":"gR8z2","primary-button":"g5J4K"};